<div class="padding-medium padding-top-none">
  <div class="grid align-center">
    <div class="cell margin-right-medium margin-left-medium progress-nav margin-bottom-none">
      <button mat-icon-button color="primary" (click)="goBack()">
        <mat-icon>west</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="grid align-center padding-bottom-xxbig">
  <div class="cell cell-large-col-span-12">

      <div class="form-typography margin-bottom-small">
        <div class="grid">
          <div class="cell cell-small-col-span-6 cell-medium-col-start-2 cell-large-col-span-6 cell-large-col-start-4 mobile-horizontal-padding">
            <div class="open-form-info margin-bottom-large padding-medium">
              <p class="margin-none"> If your claim relates to a medical emergency, personal liability or legal costs please contact our 24/7 Emergency Support line on <a href="tel:{{emergencyLinkNumber}}">{{ emergencyLinkText }}</a>.</p>
            </div>
            <div class="content-container">
              <h1 class="margin-bottom-medium">What are you claiming for today?</h1>
              <p class="margin-bottom-large">Please submit a separate claim for each event you're claiming for.</p>
            </div>
            <div *ngIf="form">
              <open-tile-radio [question]="triageQuestion" [form]="form"></open-tile-radio>
            </div>
          </div>
        </div>
      </div>

      <div class="handover-detail-section margin-bottom-small" [ngClass]="{ 'appear': handoverDetails.tpaUrl, 'disappear': !handoverDetails.tpaUrl }">
        <div class="grid">
          <div class="cell cell-small-col-span-6 cell-medium-col-start-2 cell-large-col-span-6 cell-large-col-start-4">
            <div class="handover-detail-card padding-medium margin-horizontal-medium margin-bottom-large" *ngIf="handoverDetails.tpaUrl">
              <div class="handover-detail-card-image" *ngIf="handoverDetails.tpaIcon">
                <img [src]="apiEndpoint + '/media/' + handoverDetails.tpaIcon" />
              </div>
              <h4 class="margin-vertical-small" *ngIf="handoverDetails.tpaSection.title" [innerHtml]="handoverDetails.tpaSection.title"></h4>
              <p class="text-small" *ngIf="handoverDetails.tpaSection.content">{{handoverDetails.tpaSection.content}}</p>
            </div>
          </div>
        </div>
        <div class="text-center padding-horizontal-medium" *ngIf="handoverDetails.tpaUrl">
          <button mat-flat-button color="primary" class="margin-bottom-large" mat-flat-button color="primary" (click)="executeCallToAction()">Continue</button>
        </div>
      </div>

    <ng-container *ngIf="fetchingHandoverData">
      <div class="padding-xxbig flex flex-justify-center">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </ng-container>
  </div>
</div>
